export default __webpack_public_path__ + "static/media/my-account.142f0ced.svg";